import React, { useEffect, useState } from 'react';
import { Await, useAsyncValue, useLoaderData } from 'react-router-dom';
import { useMemo } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from '@mui/x-data-grid';
import { HLROperationListItem } from "services/apiService";
import { Box, Button, CircularProgress, colors } from '@mui/material';
import { format } from "date-fns";
import { checkPendingHlrOperationWithInfobip, downloadCsv } from 'router/actions'
import { setMessage } from 'messages/messages';
import { ToastContainer } from 'react-toastify';


const HlrOperationTable = ({ hlroperation_list }: { hlroperation_list: HLROperationListItem[] }) => {
    let filtered_list = [...hlroperation_list].sort((a, b) => {
        const dateA = new Date(a.operation_date).getTime();
        const dateB = new Date(b.operation_date).getTime();
        return dateB - dateA;
    });
    const [pageSize, setPageSize] = React.useState<number>(5);
    const columns: GridColDef[] = [
        { field: "id", headerName: "id", width: 90 },
        {
            field: "username",
            headerName: "User",
            width: 150,
        },
        {
            field: "count_operation",
            headerName: "Size",
            type: "number",
            width: 150,
            editable: true,
        },
        {
            field: "operation_date",
            headerName: "Date Operation",
            width: 150,
            renderCell: (params: GridRenderCellParams<string>) =>
                params.value
                    ? format(new Date(params.value), `dd/MM/yyyy ${params.value.substring(11, 13)}:${params.value.substring(14, 16)}`)
                    : "Invalid date format"

        },
        {
            field: "status",
            headerName: "Status",
            type: "number",
            width: 100,
            renderCell: (params: GridRenderCellParams<string>) => {
                const statusStyle: React.CSSProperties = {
                    display: 'inline-block',
                    width: '100%',
                    textAlign: 'center',
                    padding: '8px', // Adjust as needed
                    borderRadius: '4px', // Adjust as needed
                    color: 'white',
                    backgroundColor: params.row.status === "finished" ? 'green' : 'orange'
                };

                return (
                    <span style={statusStyle}>
                        {params.row.status === "finished" ? "Finished" : "Pending"}
                    </span>
                );
            }
        },

        // ============================== ACTION BUTTONS  =============================
        {
            field: "file_path",
            headerName: "Action",
            width: 200,
            renderCell: (params: GridRenderCellParams<string>) => {
                if (params.row.status === "pending") {
                    return (
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                console.log("Checking active because the status of file is " + params.row.status);
                                checkPendingHlrOperationWithInfobip()
                            }}
                        >
                            Check hlr
                        </Button>
                    );
                } else if (params.row.status === "finished") {
                    console.log("Status du fichier est : " + params.row.status + ", donc bouton download activé");
                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                const path = params.row.file_path;
                                downloadCsv({ file_path: path });
                            }}
                        >
                            Download
                        </Button>
                    );
                } else {
                    console.log("Status not found in file path");
                    return null;
                }
            }
        }
        
    ];

    return (
        <DataGrid rows={filtered_list} columns={columns} components={{ Toolbar: GridToolbar }} getRowId={(row) => row.id}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
        />
    )
}

const HlrOperations = () => {
    const hlroperation_list = useAsyncValue() as HLROperationListItem[]

    const list_hlroperation = useMemo(
        () => hlroperation_list,
        [hlroperation_list]
    )

    return (
        <HlrOperationTable hlroperation_list={list_hlroperation} />
    )
}

const HLROperationList = () => {
    const loaderData = useLoaderData() as {
        hlroperations: Promise<HLROperationListItem[]>;
    };
    return (
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading HLR Operations...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.hlroperations}
                errorElement={<p>Error while loading HLR Operations data</p>}
            >
                <HlrOperations />
                <ToastContainer />
            </Await>
        </React.Suspense>
    );
}

export default HLROperationList;